import { defineStore } from 'pinia';

export default defineStore('globalStore', {
  state: () => ({
    locale: 'en-US',
    translations: {},
    countries: [],
    currentCountry: null,
    states: [],
    courses: [],
    ssrSearchMeta: null,
  }),
  getters: {
    getLocale: (state) => state.locale,
    getTranslations: (state) => state.translations,
    getCountries: (state) => state.countries,
    getCurrentCountry: (state) => state.currentCountry,
    getStates: (state) => state.states,
    getCourses: (state) => state.courses,
    getSSRSearchMeta: (state) => state.ssrSearchMeta,
  },
  actions: {
    setInitialState() {
      // Legacy SPA seeding path. During SSR the store is seeded directly by
      // `entry-server.js` from server-computed `appData`, so this action is
      // a no-op on the server. Guarding here keeps the action safe to call
      // from anywhere without crashing the SSR render.
      if (typeof window === 'undefined') return;

      const {
        locale,
        translations = {},
        countries,
        currentCountry,
      } = window.AppData || {};

      this.setLocale(locale);
      this.setTranslations(translations);
      this.setCountries(countries);
      this.setCurrentCountry(currentCountry);
    },
    setLocale(payload) {
      this.locale = payload;
    },
    setTranslations(payload) {
      this.translations = payload;
    },
    setCountries(payload) {
      const sortCountries = (a, b) => {
        if (a[1] < b[1]) return -1;
        if (a[1] > b[1]) return 1;
        return 0;
      };

      const sortedPayload = Object.entries(payload).sort(sortCountries);
      this.countries = sortedPayload;
    },
    setStates(payload) {
      this.states = payload;
    },
    setCurrentCountry(payload) {
      this.currentCountry = payload;
    },
    setCourses(payload) {
      this.courses = payload;
    },
    setSSRSearchMeta(payload) {
      this.ssrSearchMeta = payload;
    },
  },
});
